import React, { useEffect, useState } from "react";
import { array, object, string, number } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import assetify from "@quintype/framework/assetify";

import StoryContent from "../../molecules/StoryContent";
import KeyHighlights from "../../molecules/KeyHighlights";
import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import StoryPageMetaData from "../../molecules/StoryPageMetaData";
import LiveText from "../../atoms/LiveText";
import DefaultImage from "../../atoms/CardImage/default.svg";

import { getKeyHighlights } from "../../utils/utils";
import { getStory } from "../../helper/api";
import DfpAd from "../../dfp-ad";

import "./liveBlog.m.css";

const LiveBlogTemplate = ({ story, imageElements, publisherAttributes, jwtToken, scrollIndex }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [newStory, setNewStory] = useState(story);
  const [showKeyHighlights, setShowKeyHighlights] = useState(false);
  const keyHighlights = getKeyHighlights(newStory.cards);
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;
  const highlightsText = publisherAttributes.lang === "en" ? "HIGHLIGHTS" : "এক নজরে";

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
    global.deviceWidth > 1263 && setIsDesktop(!isDesktop);

    if (!isClosed) {
      const interval = setInterval(() => {
        getStory(story.id).then((response) => {
          if (response.story.metadata["is-closed"]) {
            clearInterval(interval);
          }
          setNewStory(response.story);
        });
      }, 60000);
      return () => clearInterval(interval);
    }
  }, []);

  const toggleKeyHighlights = () => {
    setShowKeyHighlights(!showKeyHighlights);
  };

  return (
    <div styleName="wrapper">
      <div styleName="ad-slot" className="top-ad">
        <DfpAd
          adtype={publisherAttributes === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}
          targetStory={story}
          slotId={`story_${scrollIndex}-t1`}
        />
      </div>
      {story["hero-image-s3-key"] && (
        <CardImage
          story={newStory}
          widths={isMobile ? [375] : [1140]}
          aspectRatio={isMobile ? [16, 9] : [1200, 574]}
          imageType={isMobile ? "image3x2" : "image1200x574"}
          showStoryTypeIcon={false}
        />
      )}
      <div
        styleName={`data-wrapper ${keyHighlights && keyHighlights.length > 0 ? "data-wrapper-with-keyHighlights" : ""}`}
      >
        {isMobile && (
          <div styleName="headline">
            <LiveText story={newStory} lang={publisherAttributes.lang} />
            {story.subheadline && (
              <Headline
                text={story.subheadline}
                headlineType={16}
                headerLevel={2}
                className="story-sub-headline"
                styleName={subHeadlineStyle}
              />
            )}
            <Headline
              text={newStory.headline}
              headlineType={9}
              headerLevel={2}
              className={`story-headline ${publisherAttributes.lang}-story-headline`}
            />
          </div>
        )}
        {isMobile && <StoryPageMetaData story={newStory} lang={publisherAttributes.lang} />}
        {keyHighlights.length > 0 && (
          <div styleName="key-highlights-wrapper">
            {isMobile && (
              <div
                className={`highlights-text ${showKeyHighlights ? "highlights-up" : ""}
                  ${publisherAttributes.lang === "bn" ? "bn-highlights-text" : ""}`}
                onClick={toggleKeyHighlights}
              >
                {highlightsText}
              </div>
            )}
            {(isDesktop || showKeyHighlights) && <KeyHighlights keyHighlights={keyHighlights} />}
          </div>
        )}
        {isDesktop && (
          <div styleName="r1-ad">
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"}
              targetStory={story}
              slotId={`story_${scrollIndex}-r1`}
            />
          </div>
        )}
        <div styleName="content-wrapper">
          {!isMobile && (
            <div styleName="headline">
              <LiveText story={newStory} lang={publisherAttributes.lang} />
              {story.subheadline && (
                <Headline
                  text={story.subheadline}
                  headlineType={16}
                  headerLevel={2}
                  className={`story-sub-headline`}
                  styleName={subHeadlineStyle}
                />
              )}
              <Headline
                text={newStory.headline}
                headlineType={9}
                headerLevel={1}
                className={`story-headline ${publisherAttributes.lang}-story-headline`}
              />
            </div>
          )}
          <StoryContent
            story={newStory}
            slicedStoryCards={newStory.cards}
            isLiveBlog={true}
            showMetadata={!isMobile}
            checkKeyElements={keyHighlights.length > 0}
            imageElements={imageElements}
            jwtToken={jwtToken}
            datatrackingcategory="Live Sub Section"
            datatrackingaction="Click"
            scrollIndex={scrollIndex}
          />
        </div>
      </div>
      {scrollIndex < 4 && (
        <div className="sun-logo">
          <img src={`${assetify(DefaultImage)}`} alt="sun" />
        </div>
      )}
    </div>
  );
};

const LiveBlog = ({ story, imageElements, publisherAttributes, jwtToken, scrollIndex }) => (
  <div className="story-grid">
    <LiveBlogTemplate
      story={story}
      imageElements={imageElements}
      publisherAttributes={publisherAttributes}
      jwtToken={jwtToken}
      scrollIndex={scrollIndex}
    />
  </div>
);

LiveBlogTemplate.propTypes = {
  story: object.isRequired,
  imageElements: array,
  publisherAttributes: object,
  jwtToken: string,
  scrollIndex: number,
};

LiveBlog.propTypes = {
  story: object.isRequired,
  imageElements: array,
  publisherAttributes: object,
  jwtToken: string,
  scrollIndex: number,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
});

export default connect(mapStateToProps, null)(LiveBlog);
